//  For each product on the page
document.querySelectorAll('.productV4').forEach(((section, index) => {
    const product = JSON.parse(section.querySelector(".productJSON").textContent);
    const hasSticky = !!section.querySelector(".productV4StickyATC");
    const hasSub = !!section.querySelector(".productV4Subscribe");
    let activeVariant = JSON.parse(section.querySelector(".activeVariantJSON").textContent);
    let quantity = 1;

    /************
     Thumbs Swiper
     ************/

    const thumbsSwiper = new Swiper(section.querySelector('.productV4Thumbnails.swiper'), {
        slidesPerView: 'auto',
        spaceBetween: 8,
        // grabCursor: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    })

    /************
     Product Swiper
     ************/

    let productImages = new Swiper(section.querySelector('.productV4Swiper'), {
        slidesPerView: 1,
        breakpoints: {
            800: {
                spaceBetween: 20,
                pagination: false
            }
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        spaceBetween: 40,
        thumbs: {
            swiper: thumbsSwiper,
        }
    });

    /**************
     Product FAQs
     ***************/

    section.querySelectorAll('.productV4FaqsItemButton').forEach(el => {
        el.addEventListener('click', function () {
            this.classList.toggle('active');
        })
    })


    /**************
     Update Product
     ***************/

    // update active variant on input changes
    section.querySelectorAll("input, select").forEach(function (element) {
        element.addEventListener("change", function () {
            section.querySelectorAll('.productV4FormOptionsItemValuesLabel').forEach(label => label.classList.remove('active'));
            element.closest('.productV4FormOptionsItemValuesLabel').classList.add('active');
            updateProduct().catch(err => console.error(err));
        });
    })

    async function updateProduct() {
        // Find the active variant
        if (product.variants.length === 1) {
            // default fallback
            activeVariant = product.variants[0];
        } else {
            // collect options from inputs
            let options = [];
            section.querySelectorAll(`.productV4FormOptionsItem`).forEach(group => {
                options.push(group.querySelector(`input:checked`).value);
            });

            // find new variant based on the options
            activeVariant = product.variants.find((variant) => {
                return JSON.stringify(variant.options) === JSON.stringify(options)
            });
        }

        // check if variant wasn't found
        if (!activeVariant) {
            section.querySelectorAll(".productV4ATC").forEach(button => button.disabled = true);
            section.querySelectorAll(".productV4ATCText").forEach(button => button.textContent = "Not Available");
            section.querySelectorAll('.productV4StickyATC').forEach(button => button.disabled = true);
            section.querySelectorAll(".productV4StickyATCText").forEach(button => button.textContent = "Not Available");
            return;
        }
        /**************
         Price
         ***************/


            // get the pricing elements
        const compareEl = section.querySelector(".productV4PriceCompare");
        const realEl = section.querySelector(".productV4PriceReal");
        const discount = section.querySelector(".productV4PriceDiscount");

        // if subscription is enabled, use subscription price

        if (hasSub && section.querySelector('.productV4Subscribe').classList.contains('active')) {
            // if there's no compare at price, use the regular price and compare it to the subscription price
            const comparePrice = (activeVariant.compare_at_price != null && activeVariant.compare_at_price !== '') ? activeVariant.compare_at_price : activeVariant.price;
            if (comparePrice && comparePrice > activeVariant.selling_plan_allocations[0].price) {
                // update and show the compare at price
                compareEl.classList.remove('empty')
                compareEl.textContent = price(comparePrice);

                // change the color of the real price element to red
                realEl.classList.remove('noSale');

                // update the price to the subscription price
                realEl.textContent = price(activeVariant.selling_plan_allocations[0].price);

                // update the discount
                if (section.querySelector('input:checked').dataset.sub) {
                    discount.classList.add('active');
                    discount.textContent = section.querySelector('input:checked').dataset.sub + '% Off';
                } else {
                    discount.classList.remove('active');
                }
            }

        } else {
            // if there's no subscription active, use the regular price and compare at price
            const compPrice = (activeVariant.compare_at_price != null && activeVariant.compare_at_price !== '') ? activeVariant.compare_at_price : '';
            if (compPrice) {
                if (compPrice > activeVariant.price) {
                    compareEl.classList.remove('empty')
                    compareEl.textContent = price(activeVariant.compare_at_price);

                    // change the color of the real price element to red
                    realEl.classList.remove('noSale');
                }
            } else {
                // hide the compare price element
                compareEl.textContent = '';
                compareEl.classList.add('empty')

                // change the color of the real price element to blue-black
                realEl.classList.add('noSale');
            }

            // update the discount if there is one and it isn't null
            if (section.querySelector('input:checked')?.dataset.otp && section.querySelector('input:checked')?.dataset.otp !== '') {
                discount.classList.add('active');
                discount.textContent = section.querySelector('input:checked')?.dataset.otp;
            } else {
                discount.classList.remove('active');
            }
            realEl.textContent = price(activeVariant.price);
        }
        /**************
         ATC Enable/Disable
         ***************/

        // check if the variant is in stock
        if (activeVariant.available) {
            section.querySelector(".productV4ATC").disabled = false;
            section.querySelectorAll(".productV4ATCText").textContent = "Add To Cart";
        } else {
            section.querySelector(".productV4ATC").disabled = true;
            section.querySelectorAll(".productV4ATCText").textContent = "Sold Out";
            // return;
        }

        // update url with variant id so the selected options are maintained on refresh, but not on the initial load
        if (product.variants[0].id !== activeVariant.id) {
            let url = new URL(window.location.href);
            url.searchParams.set("variant", activeVariant.id);
            window.history.replaceState({}, "", url);
        } else {

            let url = new URL(window.location.href);
            url.searchParams.delete("variant");
            window.history.replaceState({}, "", url);

        }
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    updateProduct().catch(err => console.error(err));

    /**************
     Toggle Subscription
     ***************/

    if(hasSub) {
        section.querySelector('.productV4Subscribe').addEventListener('click', async function () {
            const parent = section.querySelector('.productV4Form');
            if (this.classList.contains('active')) {
                // remove active class from the button and remove subscription class from the section
                this.classList.remove('active');

                // remove the bg color
                this.style.backgroundColor = 'transparent';

                section.querySelectorAll('.sub').forEach(el => el.classList.remove('sub'));

                // add back the original prices
                parent.querySelectorAll('.productV4FormOptionsItemValuesLabelPrice').forEach(el => {
                    el.querySelector('.productV4FormOptionsItemValuesLabelPriceReal').textContent = el.dataset?.realOtp;
                });

                parent.querySelectorAll('.productV4FormOptionsItemValuesLabelPriceCompare.originalPrice').forEach(el => {
                    el.textContent = '';
                });

                // update the discounts
                parent.querySelectorAll('.productV4FormOptionsItemValuesLabelDiscount').forEach(discount => {
                    // if the otp discount is blank, hide it
                    if (discount.dataset.otp === '') {
                        discount.style.opacity = 0;
                    } else {
                        // otherwise show it
                        discount.style.opacity = 1;
                        discount.textContent = discount.dataset.otp;
                    }
                })

                // update product
                updateProduct().catch(err => console.error(err));
                return;
            }
            // add active class to the button and add subscription class to the section
            this.classList.add('active');
            // add the bg color
            this.style.backgroundColor = this.dataset?.activeColor;
            parent.classList.add('sub');

            // show the free shipping message
            parent.querySelectorAll('.productV4FormOptionsItemValuesLabelFree').forEach(el => el.classList.add('sub'));

            // update the products to show their subscription prices
            parent.querySelectorAll('.productV4FormOptionsItemValuesLabelPrice').forEach(sub => sub.classList.add('sub'));
            parent.querySelectorAll('.productV4FormOptionsItemValuesLabelPrice').forEach(el => {
                if (el.querySelector('.productV4FormOptionsItemValuesLabelPriceCompare.originalPrice')) {
                    el.querySelector('.productV4FormOptionsItemValuesLabelPriceCompare.originalPrice').textContent = el.dataset?.realOtp;
                }
                el.querySelector('.productV4FormOptionsItemValuesLabelPriceReal').textContent = el.dataset?.realSub;
            });

            // update the discounts
            parent.querySelectorAll('.productV4FormOptionsItemValuesLabelDiscount').forEach(discount => {
                // if the sub discount is blank, hide it
                if (discount.dataset.sub === '') {
                    discount.style.opacity = 0;
                } else {
                    // otherwise show it
                    discount.style.opacity = 1;
                    discount.textContent = discount.dataset.sub;
                }
            })

            // update the price discount background color
            section.querySelector('.productV4PriceDiscount').classList.add('sub');

            // show the FOMO timer
            section.querySelector('.productV4GiftsFOMO').classList.add('sub');

            // update product
            updateProduct().catch(err => console.error(err));
        })
    }

    /**************
     Product ATC
     ***************/

    section.querySelector(".productV4ATC").addEventListener("click", async function () {
        const hasSubscription = section.querySelector('.productV4Form')?.classList.contains('sub');
        this.classList.add("loading");
        let formData = {}
        if (hasSubscription) {
            formData = {
                items: [{
                    quantity: quantity,
                    id: activeVariant.id,
                    selling_plan: hasSubscription ? activeVariant.selling_plan_allocations[0].selling_plan_id : ''
                },

                    {
                        id: othershipAppID,
                        quantity: 1
                    },
                ]
            };
        } else {
            formData = {
                items: [{
                    quantity: quantity,
                    id: activeVariant.id,
                }]
            }
        }

        // add to cart
        await addProduct(formData);

        // open cart
        await openCart(false);

        // remove loading animation
        this.classList.remove("loading");

    });

    /******************
     Product Sticky ATC
     ******************/


    if (hasSticky) {
        // listen for product area to scroll off page
        window.addEventListener('scroll', () => {

            let productBottom = section.getBoundingClientRect().bottom;
            let productTop = section.getBoundingClientRect().top;
            let productHeight = section.getBoundingClientRect().height;
            let previousProductSection = document.querySelectorAll('.productV4')[index - 1];

            // if the first product section is in view or we've scrolled past the entire first or previous product section, toggle the sticky ATC
            if (index === 0) {
                if (!productTop) return;
                if (productTop <= (productHeight / 3) || productBottom < 0) {
                    section.querySelector('.productV4StickyATC').classList.remove('active');
                } else {
                    section.querySelector('.productV4StickyATC').classList.add('active');
                }

                // for the index that isn't first or last:
                // once the previous product section is scrolled off the page, allow the sticky ATC to be visible for the other product sections only if the product section not in view
            } else if (index > 0 && index !== document.querySelectorAll('.productV4').length - 1) {
                // or we haven't scrolled past the product section
                if (!previousProductSection) return;
                if (previousProductSection.getBoundingClientRect().bottom < 0) {

                    if (productTop <= (productHeight / 3) || productBottom < 0) {
                        section.querySelector('.productV4StickyATC').classList.remove('active');
                    } else {
                        section.querySelector('.productV4StickyATC').classList.add('active');
                    }
                } else {
                    section.querySelector('.productV4StickyATC').classList.remove('active');
                }
            }
                // if it's the last index:
            // always show the sticky ATC once the product section is scrolled off the page
            else {
                // check if there's a previous product section
                if (!previousProductSection) return;
                if (previousProductSection.getBoundingClientRect().bottom < 0) {
                    if (productTop <= (productHeight / 3) && productBottom > 0) {
                        section.querySelector('.productV4StickyATC').classList.remove('active');
                    } else {
                        section.querySelector('.productV4StickyATC').classList.add('active');
                    }
                } else {
                    section.querySelector('.productV4StickyATC').classList.remove('active');
                }
            }

        });

        section.querySelector(`.productV4StickyATCButton`).addEventListener("click", function (event) {
            event.preventDefault();
            const top = section.querySelector('.productV4Content').getBoundingClientRect().top + window.scrollY + 40;

            // check if the alt layout is being used
            let descriptionHeight;
            if(!section.querySelector('.productV4Info').classList.contains('hidden')) {
                 descriptionHeight = section.querySelector('.productV4Info').getBoundingClientRect().height;
            }
            window?.scrollTo({
                behavior: "smooth",
                top: top + descriptionHeight ? top + descriptionHeight : top
            })

        });
    }
}));

/**************
 Countdown Timer
 ***************/


// Function to update the countdown display
function updateCountdown() {

    // get the target time in minutes
    let minutes = 13;
    let seconds = 0;
    let countdownInterval;

    document.querySelectorAll('.productV4GiftsFOMOTimerItemMinutes').forEach((el) => el.innerText = minutes);
    document.querySelectorAll('.productV4GiftsFOMOTimerItemSeconds').forEach((el) => el.innerText = seconds);


    // for every second, update the timer
    countdownInterval = setInterval(() => {

        // get the current time from the text context and count down
        let minutes = parseInt(document.querySelectorAll('.productV4GiftsFOMOTimerItemMinutes')[0].innerText);
        let seconds = parseInt(document.querySelectorAll('.productV4GiftsFOMOTimerItemSeconds')[0].innerText);


        // update the timer
        seconds--;

        // Add zero if seconds is less than 10
        if (seconds < 10 && seconds >= 0) {
            seconds = seconds.toString().padStart(2, '0');
        }

        if (seconds < 0 && minutes > 0) {
            // if seconds is less than 0, decrement minutes and reset seconds to 59
            minutes--;
            seconds = 59;
        }

        // check if the timer is over
        if (minutes === 0 && Number(seconds) === 0) {
            // make sure the timer is set to 0
            document.querySelectorAll('.productV4GiftsFOMOTimerItemSeconds').forEach((el) => el.innerText = '00');
            clearInterval(countdownInterval);
            return;
        }

        document.querySelectorAll('.productV4GiftsFOMOTimerItemMinutes').forEach((el) => el.innerText = minutes);
        document.querySelectorAll('.productV4GiftsFOMOTimerItemSeconds').forEach((el) => el.innerText = seconds.toString().padStart(2, '0')
        );

    }, 1000);

}

updateCountdown();

/**************
 Try Respire Buttons and Announcement Bar Click
 ***************/

document.querySelectorAll(`.button[href="#"], a[href="#"]`).forEach(button => button.addEventListener("click", function (event) {
    event.preventDefault();

    // get the first product section
    const firstProduct = document.querySelector('.productV4');
    // get the top of the first product section
    const top = firstProduct.querySelector('.productV4Content').getBoundingClientRect().top + window.scrollY + 40;

    // check if the alt layout is being used
    let descriptionHeight;
    if(!firstProduct.querySelector('.productV4Info').classList.contains('hidden')) {
        descriptionHeight = firstProduct.querySelector('.productV4Info').getBoundingClientRect().height;
    }

    // if its mobile, scroll to the product options
    if(window.innerWidth <= 800) {
        window?.scrollTo({
            behavior: "smooth",
            top: top + descriptionHeight ? top + descriptionHeight : top
        })
    }
    // otherwise scroll to the top of the product
    else {
        firstProduct?.scrollIntoView({
            top: 0,
            behavior: "smooth"
        })
    }

}));

/**************
 Announcement Bar
 ***************/

const productData = document.querySelector('.productV4').dataset;
const announcement = document.querySelector('.announcementV3');
if(announcement){
    announcement.style.background = productData.announceCol;

    // the badge is optional in the announcement settings
    const announcementBadge = announcement.querySelector('.announcementV3Badge');
    if (announcementBadge) {
        announcementBadge.style.backgroundColor = productData.badgeCol;
        announcementBadge.style.color = productData.badgetxtColor;
    }
}


// if the subscription button isn't active, toggle the subscription button
document.querySelectorAll('.productV4Subscribe').forEach(button => {
    if (!button?.classList.contains('active')) {
        button?.click();
    }
});

// listen for changes in the DOM to check if the Othership Breathwork App Item is in the cart
// to remove the quantity selector buttons
const observer = new MutationObserver(async (mutations) => {
    // check if the Othership Breathwork App item is in the cart
    let hasOthership = cart.items.find(item => item.variant_id === othershipAppID);

    for (const mutation of mutations) {
        if (mutation.type === 'childList') {
            if (hasOthership) {
                // disable the quantity selector for the Othership Breathwork App item
                const othershipItem = document.querySelector(`.miniCartBodyItem[key="${hasOthership.key}"]`);
                if (othershipItem) {
                    // the mini cart omits the quantity selector on free line items, so this no-ops while the app is $0
                    othershipItem.querySelectorAll('.miniCartBodyItemQuantityPlus, .miniCartBodyItemQuantityMinus').forEach(button => button.disabled = true);
                }
            }
        }
    }
});

// start observing the cart body for changes
observer.observe(document.querySelector("#miniCartBody"), {
    childList: true,
    subtree: true
})
